/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleMerchantDestinationSummaryData
 */
export interface GoogleMerchantDestinationSummaryData {
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantDestinationSummaryData
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantDestinationSummaryData
     */
    reportingContext?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantDestinationSummaryData
     */
    countryCode?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantDestinationSummaryData
     */
    productCount?: number;
}

/**
 * Check if a given object implements the GoogleMerchantDestinationSummaryData interface.
 */
export function instanceOfGoogleMerchantDestinationSummaryData(value: object): value is GoogleMerchantDestinationSummaryData {
    return true;
}

export function GoogleMerchantDestinationSummaryDataFromJSON(json: any): GoogleMerchantDestinationSummaryData {
    return GoogleMerchantDestinationSummaryDataFromJSONTyped(json, false);
}

export function GoogleMerchantDestinationSummaryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantDestinationSummaryData {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'reportingContext': json['reportingContext'] == null ? undefined : json['reportingContext'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'productCount': json['productCount'] == null ? undefined : json['productCount'],
    };
}

export function GoogleMerchantDestinationSummaryDataToJSON(json: any): GoogleMerchantDestinationSummaryData {
    return GoogleMerchantDestinationSummaryDataToJSONTyped(json, false);
}

export function GoogleMerchantDestinationSummaryDataToJSONTyped(value?: GoogleMerchantDestinationSummaryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'reportingContext': value['reportingContext'],
        'countryCode': value['countryCode'],
        'productCount': value['productCount'],
    };
}

